export const timeTypeOptions = [
  {
    value: 1,
    label: 'Ngày',
  },

  {
    value: 2,
    label: 'Tháng',
  },
  {
    value: 3,
    label: 'Năm',
  },
];

export const CUSTOMER_TYPE = {
  INDIVIDUAL: 1, // ca nhan
  BUSINESS: 2, // doanh nghiep
  LEADS: 3, // tiem nang
} 

export const customerTypeOptions = [
  {
    value: CUSTOMER_TYPE.INDIVIDUAL,
    label: 'Cá nhân',
  },
  {
    value: CUSTOMER_TYPE.BUSINESS,
    label: 'Doanh nghiệp',
  },
  {
    value: CUSTOMER_TYPE.LEADS,
    label: 'Tiềm năng',
  },
];

export const OrOrAnd = [
  {
    value: 1,
    label: 'Hoặc',
  },

  {
    value: 2,
    label: 'Và',
  }
];

